import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Pagination } from 'common/components/layout';
import { productListEvent } from 'common/helpers/customEvents';
import { getCollectionBySlug } from 'redux/collections/reducers';
import { listProducts } from 'redux/products/actions';

import Template from './components/ProductCollectionTemplate';
import { collectionTemplate } from './defaultTemplates';

class Collection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1
    };
  }

  listProducts = (page) => {
    this.setState({ page });
    const { props } = this;
    const { collectionSlug } = this.props;
    props.listProducts(collectionSlug, null, page, 'Personalization Block');
  };

  render() {
    const { settings, collection, products } = this.props;
    const { page } = this.state;
    if (!settings.data || !collection) {
      return null;
    }
    const productArray = collection.productIds.map((productId) => {
      const product = products.data[productId];
      return product;
    });
    const newTemplate = collection.productTemplate || collectionTemplate;
    productListEvent(collection);
    return (
      <>
        <Template
          products={productArray}
          template={newTemplate}
          settings={settings}
          collection={collection}
        />
        <Pagination
          totalRecords={collection.productCount}
          page={page || 1}
          search={this.listProducts}
        />
      </>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  collection: getCollectionBySlug(state.collection, ownProps.collectionSlug),
  products: state.product,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listProducts
})(Collection);
